module.exports = __webpack_public_path__ + "media/images/icon/icons8-Info-2f5ce6afc2bebaf7fb41edc127206d2e.png";